import { PasswordStrength } from '../types';

interface PasswordStrengthIndicatorProps {
  strength: PasswordStrength;
}

const PasswordStrengthIndicator = ({ strength }: PasswordStrengthIndicatorProps) => {
  return (
    <div className="mt-2 space-y-2">
      <div className="flex items-center gap-2">
        <div className="flex-1 h-2 bg-muted rounded-full overflow-hidden">
          <div
            className="h-full transition-all duration-300"
            style={{
              width: `${(strength.score / 5) * 100}%`,
              backgroundColor: strength.color,
            }}
          />
        </div>
        <span className="text-xs font-medium" style={{ color: strength.color }}>
          {strength.label}
        </span>
      </div>

      <div className="space-y-1">
        <div className="flex items-center gap-2 text-xs">
          <div
            className={`w-1.5 h-1.5 rounded-full ${
              strength.requirements.minLength ? 'bg-success' : 'bg-muted-foreground'
            }`}
          />
          <span
            className={
              strength.requirements.minLength ? 'text-success' : 'text-muted-foreground'
            }
          >
            At least 8 characters
          </span>
        </div>
        <div className="flex items-center gap-2 text-xs">
          <div
            className={`w-1.5 h-1.5 rounded-full ${
              strength.requirements.hasUpperCase ? 'bg-success' : 'bg-muted-foreground'
            }`}
          />
          <span
            className={
              strength.requirements.hasUpperCase ? 'text-success' : 'text-muted-foreground'
            }
          >
            One uppercase letter
          </span>
        </div>
        <div className="flex items-center gap-2 text-xs">
          <div
            className={`w-1.5 h-1.5 rounded-full ${
              strength.requirements.hasLowerCase ? 'bg-success' : 'bg-muted-foreground'
            }`}
          />
          <span
            className={
              strength.requirements.hasLowerCase ? 'text-success' : 'text-muted-foreground'
            }
          >
            One lowercase letter
          </span>
        </div>
        <div className="flex items-center gap-2 text-xs">
          <div
            className={`w-1.5 h-1.5 rounded-full ${
              strength.requirements.hasNumber ? 'bg-success' : 'bg-muted-foreground'
            }`}
          />
          <span
            className={
              strength.requirements.hasNumber ? 'text-success' : 'text-muted-foreground'
            }
          >
            One number
          </span>
        </div>
        <div className="flex items-center gap-2 text-xs">
          <div
            className={`w-1.5 h-1.5 rounded-full ${
              strength.requirements.hasSpecial ? 'bg-success' : 'bg-muted-foreground'
            }`}
          />
          <span
            className={
              strength.requirements.hasSpecial ? 'text-success' : 'text-muted-foreground'
            }
          >
            One special character
          </span>
        </div>
      </div>
    </div>
  );
};

export default PasswordStrengthIndicator;